<app-navbar [title]="pageTitle">
	@if (editable) {
		<button class="btn btn-primary me-3" (click)="submit()">Zapisz</button>
	} @else {
		<button class="btn btn-primary me-3" (click)="editUnlock()">Edycja</button>
	}
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<div class="container my-4">
	<form (submit)="submit()">
		<fieldset [disabled]="!editable">
			<div class="form-floating mb-3">
				<ng-select
					[(ngModel)]="data.location"
					id="parentLocation"
					name="parentLocation"
					[multiple]="false"
					[disabled]="!editable"
					placeholder="Lokalizacja"
					required
				>
					@for (item of parentLocationSet; track item.id) {
						<ng-option [value]="item.id"> {{ item.id }} | {{ item.name }} </ng-option>
					}
				</ng-select>
			</div>
			<div class="form-floating mb-3">
				<ng-select
					[(ngModel)]="data.parentStop"
					id="parentStop"
					name="parentStop"
					placeholder="Przystanek nadrzędny"
					[disabled]="!editable"
					required
				>
					@for (item of parentStopSet; track item.id) {
						<ng-option [value]="item.id">
							{{ item.location.id }} | {{ item.location.name }} |
							{{ item.address }}
						</ng-option>
					}
				</ng-select>
			</div>
			<div class="form-floating mb-3">
				<input type="text" class="form-control" id="address" name="address" [(ngModel)]="data.address" />
				<label for="address" class="form-label">Adres</label>
			</div>

			<div class="row">
				<div
					[ngClass]="{
						'col-6': kind() === OfferTransportKind.PLANE,
						'col-12': kind() === OfferTransportKind.COACH,
					}"
					class="form-floating mb-3"
				>
					<select class="form-select" id="stopType" name="stopType" [(ngModel)]="data.stopType">
						@for (item of transportStops; track item.name) {
							<option [value]="item.value">
								{{ item.name }}
							</option>
						}
					</select>
					<label for="stopType" class="form-label" style="left: auto">Typ przystanku</label>
				</div>
				@if (kind() === OfferTransportKind.PLANE) {
					<div class="form-floating mb-3 col-6">
						<input
							type="string"
							class="form-control"
							id="iataCode"
							name="iataCode"
							[(ngModel)]="data.iataCode"
						/>
						<label for="iataCode" class="form-label" style="left: auto">Kod IATA</label>
					</div>
				}
			</div>

			<div class="row">
				<div class="form-floating mb-3 col-6">
					<input
						type="number"
						class="form-control"
						id="erpGrid"
						name="erpGridX"
						[(ngModel)]="data.erpGrid[0]"
					/>
					<label for="erpGridX" class="form-label" style="left: auto">Pozycja na siatce X</label>
				</div>
				<div class="form-floating mb-3 col-6">
					<input
						type="number"
						class="form-control"
						id="erpGridY"
						name="erpGridY"
						[(ngModel)]="data.erpGrid[1]"
					/>
					<label for="erpGridY" class="form-label" style="left: auto">Pozycja na siatce Y</label>
				</div>
			</div>
			<div class="row">
				<div class="form-floating mb-3 col-6">
					<input
						type="number"
						id="longitude"
						name="longitude"
						class="form-control"
						[(ngModel)]="data.longitude"
					/>
					<label for="longitude" class="form-label" style="left: auto">Długość geograficzna</label>
				</div>
				<div class="form-floating mb-3 col-6">
					<input
						type="number"
						id="latitude"
						name="latitude"
						class="form-control"
						[(ngModel)]="data.latitude"
					/>
					<label for="latitude" class="form-label" style="left: auto">Szerokość geograficzna</label>
				</div>
			</div>
		</fieldset>
	</form>
</div>
